export default __webpack_public_path__ + "locales/cs/InfoPanel.json?hash=ec22b352d717f8e001b38282ad013a68";